import React from 'react';
import {Modal, Button} from "react-bootstrap";
import TranslationService from "../../service/TranslationService";
import {BACK, CHANGE, CHANGE_TARIFF, CHANGE_TARIFF_WARNING} from "../../language-content/keys";

function TariffChangeModal({showTariffChange, toggleTariffChangeModal, urlDestination, history, lang}) {
    return (
        <Modal show={showTariffChange} size={"lg"} onHide={() => toggleTariffChangeModal()}
               className={"channels-modal vip-modal"}>
            <Modal.Header className="border-bottom-0 mt-3">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                        onClick={() => toggleTariffChangeModal()}>
                    <img src={process.env.REACT_APP_IMAGES_URL + '/A1_close_icon_32.png'}/>
                </button>
                <Modal.Title>
                    <h5 className="pr-4 serif-bold mb-3">
                        {TranslationService.translate(CHANGE_TARIFF, lang)}
                    </h5>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div>
                    {TranslationService.translate(CHANGE_TARIFF_WARNING, lang)}
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="btn btn-secondary no-icon" onClick={() => toggleTariffChangeModal()}>
                    {TranslationService.translate(BACK, lang)}
                </Button>
                <Button variant="btn btn-primary no-icon" onClick={() => handleOk()}>
                    {TranslationService.translate(CHANGE, lang)}
                </Button>
            </Modal.Footer>

        </Modal>
    );

    function handleOk() {
        history.push(urlDestination);
        toggleTariffChangeModal();
    }
}

export default TariffChangeModal;